<ng-container *ngIf="!!get && !!form" [formGroup]="form">
    <tt-checkbox *ngIf="get.setting_show_oh_head_delivery_cust_unreg !== '0'" ttLabel="delivery_cust_unreg" formControlName="delivery_cust_unreg"></tt-checkbox>
    <ng-container *ngIf="form.controls.delivery_cust_unreg.value === '0'">
        <tt-input *ngIf="get.setting_show_oh_head_delivery_cust_no !== '0'" ttLabel="orderhead_delivery_cust_no" formControlName="delivery_cust_no" ttReadonly></tt-input>
        <tt-search
            *ngIf="get.setting_show_oh_head_delivery_cust_name !== '0'"
            ttLabel="orderhead_delivery_cust_name"
            formControlName="delivery_cust_name"
            [ttSearch]="searchDeliveryCustomers"
            (ttOnSelected)="onDeliveryCustomerSelected($event)"
            (ttOnClear)="onDeliveryCustomerSelected()"
        ></tt-search>
        <tt-textarea *ngIf="get.setting_show_oh_head_delivery_cust_address !== '0'" ttLabel="orderhead_delivery_cust_address" formControlName="delivery_cust_address" ttReadonly></tt-textarea>
    </ng-container>
    <ng-container *ngIf="form.controls.delivery_cust_unreg.value === '1'">
        <tt-input *ngIf="get.setting_show_oh_head_delivery_cust_name !== '0'" ttLabel="orderhead_delivery_cust_name" formControlName="delivery_cust_name"></tt-input>
        <tt-textarea *ngIf="get.setting_show_oh_head_delivery_adr_street !== '0'" ttLabel="delivery_adr_street" formControlName="delivery_adr_street"></tt-textarea>
        <tt-search
            *ngIf="get.setting_show_oh_head_delivery_post_and_name_street !== '0'"
            ttLabel="delivery_postplace_id_and_name_street"
            formControlName="delivery_postplace_id_and_name_street"
            [ttSearch]="searchPostplaces"
            (ttOnSelected)="onPostPlaceStreetNameSelected($event)"
            (ttOnClear)="onPostPlaceStreetNameSelected()"
        >
            <ng-container buttons>
                <tt-form-field-button ttIcon="fas fa-plus" ttTooltip="goto_new_postplace" [ttTranslateTooltip]="true" ttGoto="postplace" [ttGotoParms]="{ postplace_id: '0' }"></tt-form-field-button>
            </ng-container>
        </tt-search>
        <tt-input *ngIf="get.setting_show_oh_head_delivery_adr_mail !== '0'" ttLabel="delivery_adr_mail" formControlName="delivery_adr_mail"></tt-input>
        <tt-search
            *ngIf="get.setting_show_oh_head_delivery_post_and_name !== '0'"
            ttLabel="delivery_postplace_id_and_name"
            formControlName="delivery_postplace_id_and_name"
            [ttSearch]="searchPostplaces"
            (ttOnSelected)="onPostplaceNameSelected($event)"
            (ttOnClear)="onPostplaceNameSelected()"
        >
            <ng-container buttons>
                <tt-form-field-button ttIcon="fas fa-plus" ttTooltip="goto_new_postplace" [ttTranslateTooltip]="true" ttGoto="postplace" [ttGotoParms]="{ postplace_id: '0' }"></tt-form-field-button>
            </ng-container>
        </tt-search>

        <tt-select
            *ngIf="get.setting_show_oh_head_delivery_country_id !== '0'"
            ttLabel="delivery_country_id"
            formControlName="delivery_country_id"
            [ttData]="countries"
            ttDataId="country_id"
            ttDataName="country_name"
        ></tt-select>
    </ng-container>
    <tt-input *ngIf="get.setting_show_oh_head_delivery_place !== '0'" ttLabel="delivery_place" formControlName="delivery_place"></tt-input>
    <tt-input *ngIf="get.setting_show_oh_head_delivery_cust_phone !== '0'" ttLabel="delivery_cust_phone" formControlName="delivery_cust_phone"></tt-input>
    <tt-input *ngIf="get.setting_show_oh_head_delivery_email !== '0'" ttLabel="orderhead_delivery_email" formControlName="delivery_email"></tt-input>
    <tt-checkbox *ngIf="get.setting_show_oh_head_deladronpurch !== '0'" ttLabel="orderhead_deladronpurch" formControlName="deladronpurch"></tt-checkbox>
    <tt-textarea *ngIf="get.setting_show_oh_head_delivery_adr_note !== '0'" ttLabel="orderhead_delivery_adr_note" formControlName="delivery_adr_note"></tt-textarea>
    <tt-select
        *ngIf="get.setting_show_oh_head_delivery_business_id !== '0'"
        ttLabel="business"
        formControlName="delivery_business_id"
        [ttData]="businesses"
        ttDataId="business_id"
        ttDataName="business_name"
    >
        <ng-container buttons>
            <tt-form-field-button ttIcon="fas fa-chevron-right" ttTooltip="goto_businesss" [ttTranslateTooltip]="true" ttGoto="businesss"></tt-form-field-button>
        </ng-container>
    </tt-select>
    <tt-select *ngIf="get.show_oh_head_delivery_coop_id === '1'" ttLabel="coop" formControlName="delivery_coop_id" [ttData]="coops" ttDataId="coop_id" ttDataName="coop_name"></tt-select>
</ng-container>
